export const filter = {
    id: "",
    name: "",
    surname: "",
    phone_number: "",
    partner_clinic_id: null,
    patronymic: "",
    note: "",
    id_code: "",
    search: "",
    created_at: "",
    updated_at: "",
    start_date: '',
    end_date: '',
};
